export default __webpack_public_path__ + "static/media/IMG_0840.3acc702f.jpeg";